export type RampVector = [number, number, number, number, number];

export const DEFAULT_RAMP_VECTOR: RampVector = [20, 30, 50, 100, 100];

const clampPercent = (value: number): number => {
  const numeric = Number.isFinite(value) ? value : 100;
  return Math.max(0, Math.min(100, Math.round(numeric)));
};

export function normalizeRampVector(input?: unknown): RampVector {
  if (!Array.isArray(input)) return [...DEFAULT_RAMP_VECTOR] as RampVector;

  const normalized = [...DEFAULT_RAMP_VECTOR].map((fallback, idx) => {
    const raw = Number((input as number[])[idx]);
    return clampPercent(Number.isFinite(raw) ? raw : fallback);
  });

  return normalized as RampVector;
}

export function normalizeRampByPillar(
  input: unknown,
  pillars: string[]
): Record<string, RampVector> {
  const source = (input && typeof input === "object" ? input : {}) as Record<string, unknown>;
  const result: Record<string, RampVector> = {};

  for (const pillar of pillars) {
    result[pillar] = normalizeRampVector(source[pillar]);
  }

  return result;
}

